import { render } from "./DispatchTable.vue?vue&type=template&id=2e83db09&ts=true"
import script from "./DispatchTable.vue?vue&type=script&lang=ts"
export * from "./DispatchTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__